import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { upcomingEvents } from '../../../mocks/events';
import { useAuth } from '../../../hooks/useAuth';
import AccountGateModal from '../../../components/feature/AccountGateModal';

export default function EventsPreview() {
  const preview = upcomingEvents.slice(0, 3);
  const { isLoggedIn } = useAuth();
  const navigate = useNavigate();
  const [showAuthGate, setShowAuthGate] = useState(false);

  const handleRsvpClick = () => {
    if (isLoggedIn) {
      navigate('/events');
    } else {
      setShowAuthGate(true);
    }
  };

  return (
    <section className="py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6 sm:px-10 lg:px-20">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div>
            <span className="text-xs font-bold tracking-widest uppercase text-pink-500 mb-4 block">
              Events
            </span>
            <h2 className="text-4xl md:text-5xl font-extrabold text-gray-900 leading-tight">
              What's happening<br />near you
            </h2>
            <p className="text-gray-500 mt-4 text-base max-w-md">
              Free meetups, family outings, community workshops — for every season of motherhood.
            </p>
          </div>
          <Link
            to="/events"
            className="inline-flex items-center gap-2 px-6 py-3 border-2 border-gray-900 text-gray-900 rounded-full text-sm font-bold hover:bg-gray-900 hover:text-white transition-all cursor-pointer whitespace-nowrap self-start md:self-auto"
          >
            View All Events
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {preview.map((event) => (
            <div
              key={event.id}
              className="group bg-white rounded-2xl overflow-hidden border border-gray-100 hover:-translate-y-1 transition-all duration-300 cursor-pointer"
            >
              <div className="relative h-52 w-full overflow-hidden">
                <img
                  src={event.image}
                  alt={event.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" />
                <div className="absolute top-4 left-4 bg-white rounded-xl px-3 py-2 text-center min-w-[52px]">
                  <div className="text-pink-500 text-xs font-bold uppercase leading-none">
                    {event.date.split(' ')[0]}
                  </div>
                  <div className="text-gray-900 text-lg font-extrabold leading-tight">
                    {event.date.split(' ')[1]?.replace(',', '')}
                  </div>
                </div>
                <div className="absolute top-4 right-4 px-3 py-1 bg-pink-600 text-white text-xs font-bold rounded-full">
                  {event.category}
                </div>
              </div>

              <div className="p-6">
                <h3 className="text-base font-bold text-gray-900 mb-4 leading-snug">{event.title}</h3>
                <div className="flex flex-col gap-1.5 mb-5">
                  <div className="flex items-center text-xs text-gray-400 gap-2">
                    <i className="ri-time-line text-pink-400"></i>
                    <span>{event.time}</span>
                  </div>
                  <div className="flex items-center text-xs text-gray-400 gap-2">
                    <i className="ri-map-pin-line text-pink-400"></i>
                    <span>{event.location}</span>
                  </div>
                </div>
                <div className="pt-4 border-t border-gray-100 flex items-center justify-between">
                  <span className="text-xs text-rose-400 font-medium">{event.spots}</span>
                  <button
                    onClick={handleRsvpClick}
                    className="px-4 py-2 bg-pink-600 text-white text-xs font-bold rounded-lg hover:bg-pink-700 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    RSVP
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

        <p className="mt-8 text-center text-xs text-gray-400">
          Many events are free or low-cost — participate at whatever level works for you.
        </p>
      </div>

      {showAuthGate && (
        <AccountGateModal
          onClose={() => setShowAuthGate(false)}
          onSuccess={() => { setShowAuthGate(false); navigate('/events'); }}
        />
      )}
    </section>
  );
}
